export const NAME = 'RagingElonMarsCoin';
